const pageType = ref('');

function setPageType(term) {
  pageType.value = term;
}

function usePageTypeStore() {
  return {
    pageType,
    setPageType
  };
}

export default usePageTypeStore;